import { createSharedComposable, useMediaQuery, usePointer as usePointerVueUse } from "@vueuse/core";
import { computed } from "vue";

function usePointerFn() {
  const { pointerType } = usePointerVueUse();

  const isMouse = computed(() => pointerType.value === "mouse");
  const isPen = computed(() => pointerType.value === "pen");
  const isTouch = computed(() => pointerType.value === "touch");

  const isFine = useMediaQuery("(pointer: fine)");
  const isCoarse = useMediaQuery("(pointer: coarse)");

  return {
    pointerType,
    isMouse,
    isPen,
    isTouch,
    isCoarse,
    isFine,
  };
}

export const usePointer = createSharedComposable(usePointerFn);
